import { MedicalForm } from '../components/MedicalForm';
import { PageContainer } from '../components/PageContainer';

export const Medical = () => {
	return (
		<PageContainer>
			<MedicalForm />
		</PageContainer>
	);
};
